import { render, staticRenderFns } from "./StartWork.vue?vue&type=template&id=0782ffb8&scoped=true&"
import script from "./StartWork.vue?vue&type=script&lang=js&"
export * from "./StartWork.vue?vue&type=script&lang=js&"
import style0 from "./StartWork.vue?vue&type=style&index=0&id=0782ffb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0782ffb8",
  null
  
)

export default component.exports